import { render, staticRenderFns } from "./ProjectProgressHome.vue?vue&type=template&id=064b8f00&scoped=true&"
import script from "./ProjectProgressHome.vue?vue&type=script&lang=js&"
export * from "./ProjectProgressHome.vue?vue&type=script&lang=js&"
import style0 from "./ProjectProgressHome.vue?vue&type=style&index=0&id=064b8f00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064b8f00",
  null
  
)

export default component.exports